import React from 'react';
import { IReturnDetailsValues, ReturnDetailsContext } from '../../contexts/returnDetails/returnDetailsContext';

export function useReturnDetails(): IReturnDetailsValues {
    const context = React.useContext(ReturnDetailsContext);
    if (!context) {
        throw new Error('useReturnDetails must be wrapped in a ReturnDetailsContextProvider');
    }
    return context;
}
